import React from "react"
import { css } from "@emotion/core"
import { useStaticQuery, Link, graphql } from "gatsby"

import { rhythm } from "../utils/typography"

export default ({ children }) => {
  const data = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
          }
        }
      }
    `
  )
  return (
    <header
      css={css`
        margin-bottom: 0;
        width: 100%;
        // display: flex;
        // align-items: center;
        // margin-bottom: ${rhythm(2)};
      `}
    >
      <div
        css={css`
          margin: 0 auto;
          max-width: 1040px;
          padding: ${rhythm(1)} 20px;
          display: flex;
          align-items: center;

          flex-direction: row;

          @media only screen and (max-width: 576px) {
            flex-direction: column;
          }
        `}
      >
        <a
          href={`/`}
          css={css`
            display: flex;
            margin-right: auto;

            @media only screen and (max-width: 576px) {
              margin-right: 0;
              margin-bottom: 20px;
            }
          `}
        >
          <img className="logo" src="/logo_v1.svg" alt="" />
        </a>
        <a className="header-menu-link" href={`/handbook/`}>
          The Handbook
        </a>
        <a className="header-menu-link" href={`/about/`}>
          About This Site
        </a>
        <a className="header-menu-link" href={`/contact/`}>
          Questions & Feedback
        </a>
      </div>
    </header>
  )
}
